'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SellerCatalogsRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SellerCatalogsRemote = exports.SellerCatalogsRemote = {
    fetchSellerEndedCatalogsById: function fetchSellerEndedCatalogsById(_ref) {
        var authToken = _ref.authToken,
            count = _ref.count,
            deployment = _ref.deployment,
            page = _ref.page,
            sellerId = _ref.sellerId,
            sortTerm = _ref.sortTerm;
        return new _promise2.default(function (resolve, reject) {
            var query = {};
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/seller/' + sellerId + '/recent', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            if (global.__SERVER__) {
                query.pageSize = count;
                query.cursor = (page - 1) * count;
                query.sortTerm = sortTerm;
            }
            request.query(query);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    },
    fetchSellerUpcomingCatalogsById: function fetchSellerUpcomingCatalogsById(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment,
            sellerId = _ref2.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/seller/' + sellerId + '/upcoming', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/sellerCatalogs.js
// module id = rdp+
// module chunks = 46